import { useMe } from '@/features/auth/useMe'

/**
 * Доступность оплаты российской картой. Три состояния, а не флаг: UI объясняет
 * автору ПРИЧИНУ отсутствия способа, и «профиль ещё не доехал / не прочитался»
 * нельзя выдавать за «почты нет» — на сетевой ошибке такой текст просто врёт.
 *
 * - `allowed` — почта есть, способ предлагаем;
 * - `no-email` — профиль прочитан, почты в нём нет: причина известна и её можно
 *   назвать;
 * - `unknown` — профиль ещё грузится, упал или токена нет вовсе: способ
 *   прячем (покупка отбилась бы), но причину не утверждаем.
 */
export type CardPaymentAccess = 'allowed' | 'no-email' | 'unknown'

/**
 * `TBANK` на бэке требует `contactEmail` ИЛИ `email` и без них отбивает покупку
 * кодом `email_required_for_tbank`; бэк прямо просит отсекать это ДО показа
 * кнопки (ответ от 14.08.2026, §3), а не ловить отказом после клика. Оба поля
 * проверяются потому, что оба проверяет сервер — боевой плеер читает тот же
 * `GET /users/me` тем же предикатом.
 *
 * Словарь отказа в `buyFailureText` остаётся страховкой: условия проверяет
 * сервер, и профиль может разойтись с ним между чтением и кликом.
 */
export const useCardPaymentAccess = (): CardPaymentAccess => {
  const { data: me, isError } = useMe()
  if (isError || !me) return 'unknown'
  return me.contactEmail || me.email ? 'allowed' : 'no-email'
}
